$(document).ready(function () {

    var visualBoxSliderOptions = {
        "default" : {
            arrows: true,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 2,
            dots: false,
            centerMode: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint:  1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        centerMode: false,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint:  576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: true,
                        variableWidth: true,
                    }
                }
            ]
        }
    }

    $(".js-newslist-preview-slider").each(function() {

        $(this).on('init reInit afterChange', function(event, slick, currentSlide){
            var totalSlides = slick.slideCount;

            $('.js-newslist-preview-slider .slick-slide').each(function(index){
                // Calcola il numero "umano" della slide (da 1 a totale)
                var slideIndex = $(this).data('slick-index') + 1;

                // Aggiunge attributi ARIA
                $(this)
                    .attr('aria-roledescription', 'slide')
                    .attr('aria-label', slideIndex + ' of ' + totalSlides);
            });
        });

        if ($(this).find('.js-newslist-preview-itemSlider').length > 1) {

            var sliderType = $(this).attr('data-slider');

            if (!sliderType) sliderType = "default";
            $(this).slick(visualBoxSliderOptions[sliderType]);

        }
    });

    $(".js-newslist").each(function() {
        $(this).slick();
    });

    $(".js-slider-custom-newslist").each(function () {
        if ($(this).hasClass("inizialized")) return;
        if ($(this).find(".slider-cards-component__slide").length > 2) {
            $(this).slick();
            $(this).addClass("inizialized");
        }
    });

});
